export var HeaderFooterTokenType;
(function (HeaderFooterTokenType) {
    HeaderFooterTokenType["ARBITRARY_TEXT"] = "Constant";
    HeaderFooterTokenType["NEWLINE"] = "Newline";
    HeaderFooterTokenType["NEWLINE_MICROSOFT"] = "NewlineMicrosoft";
    HeaderFooterTokenType["TAB"] = "Tab";
    HeaderFooterTokenType["COMMA"] = "Comma";
    HeaderFooterTokenType["SPACE"] = "Space";
    HeaderFooterTokenType["CURRENT_DATE"] = "CurrentDate";
    HeaderFooterTokenType["AGGREGATE_COUNT"] = "AggregateCount";
    HeaderFooterTokenType["AGGREGATE_TOTAL"] = "AggregateTotal";
})(HeaderFooterTokenType || (HeaderFooterTokenType = {}));
export var DateFormatType;
(function (DateFormatType) {
    DateFormatType["YEAR_LONG"] = "YEAR_LONG";
    DateFormatType["YEAR_SHORT"] = "YEAR_SHORT";
    DateFormatType["MONTH"] = "MONTH";
    DateFormatType["DATE"] = "DATE";
    DateFormatType["HOUR"] = "HOUR";
    DateFormatType["MINUTE"] = "MINUTE";
    DateFormatType["SECOND"] = "SECOND";
    DateFormatType["QUARTER"] = "QUARTER";
    DateFormatType["WEEK_OF_YEAR_ISO"] = "WEEK_OF_YEAR_ISO";
    DateFormatType["WEEK_YEAR_ISO"] = "WEEK_YEAR_ISO";
    DateFormatType["DAY_OF_YEAR"] = "DAY_OF_YEAR";
    DateFormatType["YYYYMMDD"] = "YYYYMMDD";
    DateFormatType["YYYY_MM_DD"] = "YYYY-MM-DD";
    DateFormatType["MMDDYYYY"] = "MMDDYYYY";
    DateFormatType["DDMMYYYY"] = "DDMMYYYY";
})(DateFormatType || (DateFormatType = {}));
export var DataTokenType;
(function (DataTokenType) {
    DataTokenType["ARBITRARY_TEXT"] = "Constant";
    DataTokenType["NEWLINE"] = "Newline";
    DataTokenType["NEWLINE_MICROSOFT"] = "NewlineMicrosoft";
    DataTokenType["TAB"] = "Tab";
    DataTokenType["COMMA"] = "Comma";
    DataTokenType["SPACE"] = "Space";
    DataTokenType["CURRENT_DATE"] = "CurrentDate";
    DataTokenType["ACCOUNT_AMOUNT"] = "FeeAmount";
    DataTokenType["ACCOUNT_DATE"] = "FeeDate";
    DataTokenType["FEE_FINE_TYPE"] = "FeeFineMetadata";
    DataTokenType["ITEM_INFO"] = "ItemData";
    DataTokenType["USER_DATA"] = "UserData";
    DataTokenType["CONSTANT_CONDITIONAL"] = "ConstantConditional";
    DataTokenType["AGGREGATE_COUNT"] = "AggregateNumRows";
    DataTokenType["AGGREGATE_TOTAL"] = "AggregateTotalAmount";
})(DataTokenType || (DataTokenType = {}));
